<template lang="pug">
  .coupe
    router-link.btn(:to="{name: 'constructors.constructor.install'}") Как установить этот конструктор
    hr.box__hr
    .box--inner
      .box__content#frame-container
        template(v-if="frameSrc")
          iframe.widget(:src="frameSrc")
    TutorialModal(ref="tutorial" title="Мой ConPlus")
      .tut-modal__content
        p В этом разделе вы можете настроить и установить свой ConPlus.
        p Настройки обеспечат точность расчетов стоимости шкафа для клиента и помогут получать максимум заявок.
</template>

<script>
import TutorialModal from '@/components/ui/modals/TutorialModal/TutorialModal.vue';
import config from '@/config';

export default {
  mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  },

  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
  computed: {
    frameSrc() {
      return `${config.urls.app(this.$store.getters.getToken)}?widgets=false`;
    }
  },

  methods: {
    onResize() {
      const frameContainer = document.getElementById('frame-container');
      const frameScale = (frameContainer.clientWidth - 40) / 1000;
      const frame = document.getElementsByClassName('widget')[0];
      const mediumStyle = 'position: static; width: 100%; height: 800px;';
      const smallStyle = 'position: static; width: 100%;';
      window.requestAnimationFrame(() => {
        if (frameScale < 1) {
          if (frameContainer.classList.contains('flex-container'))
            frameContainer.classList.remove('flex-container');
          const deltaX = ((frameScale - 1) * 1000) / 2;
          const deltaY = ((frameScale - 1) * 1000) / 2.5;
          frame.setAttribute(
            'style',
            `-webkit-transform: scale(${frameScale});
            -moz-transform: scale(${frameScale});
            top: ${deltaY}px;
            left: ${deltaX}px;`
          );
          frameContainer.setAttribute(
            'style',
            `height: ${frameScale * 800 + 40}px;`
          );
        } else {
          if (!frameContainer.classList.contains('flex-container')) {
            frameContainer.classList.add('flex-container');
            frameContainer.removeAttribute('style');
          }
          const bigWidth = frameContainer.clientWidth > 1020;
          if (bigWidth && frame.getAttribute('style') !== mediumStyle) {
            frame.setAttribute('style', mediumStyle);
          } else if (!bigWidth && frame.getAttribute('style') !== smallStyle) {
            frame.setAttribute('style', smallStyle);
          }
        }
      });
    }
  },

  components: {
    TutorialModal
  }
};
</script>

<style lang="scss" scoped>
.flex-container {
  display: flex;
  justify-content: center;
}
.widget {
  width: 1000px;
  height: 800px;
  overflow: scroll;
  border: 1px solid rgba(#462400, 0.3);
  position: relative;
}
</style>
